import styled from 'styled-components';

export const StyledAdminDiv = styled.div``;
